var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Contact US",
      "bg": "/images/sub/visual/sv6.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v("Contact US")])]), _c('v-simple-table', {
    staticClass: "v-simple-table v-data-table--default v-data-table--no-active text-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _c('th', [_vm._v("Person in Charge")]), _c('th', [_vm._v("E-mail")])])]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("Analyzer Package System")]), _c('td', [_vm._v("Hong-ki Park")]), _c('td', [_c('a', {
    staticClass: "primary--text text-decoration-underline ",
    attrs: {
      "href": "mailto:richard@kiesys.co.kr"
    }
  }, [_vm._v("richard@kiesys.co.kr")])])]), _c('tr', [_c('td', {
    staticClass: "border-left"
  }, [_vm._v("Byung-hyun Yoon")]), _c('td', [_c('a', {
    staticClass: "primary--text text-decoration-underline ",
    attrs: {
      "href": "mailto:bhyoon@kiesys.co.kr"
    }
  }, [_vm._v("bhyoon@kiesys.co.kr")])])]), _c('tr', [_c('td', {
    staticClass: "border-left"
  }, [_vm._v("Tae-hong Lee")]), _c('td', [_c('a', {
    staticClass: "primary--text text-decoration-underline ",
    attrs: {
      "href": "mailto:thlee@kiesys.co.kr"
    }
  }, [_vm._v("thlee@kiesys.co.kr")])])]), _c('tr', [_c('td', {
    staticClass: "border-left"
  }, [_vm._v("Jin-kyu Oh")]), _c('td', [_c('a', {
    staticClass: "primary--text text-decoration-underline ",
    attrs: {
      "href": "mailto:tedd@kiesys.co.kr"
    }
  }, [_vm._v("tedd@kiesys.co.kr")])])]), _c('tr', [_c('td', {
    staticClass: "border-left"
  }, [_vm._v("Jae-ho Roh")]), _c('td', [_c('a', {
    staticClass: "primary--text text-decoration-underline ",
    attrs: {
      "href": "mailto:jhroh@kiesys.co.kr"
    }
  }, [_vm._v("jhroh@kiesys.co.kr")])])]), _c('tr', [_c('td', [_vm._v("Corrosion Monitoring System")]), _c('td', [_vm._v("Seong-cheol Jeong")]), _c('td', [_c('a', {
    staticClass: "primary--text text-decoration-underline ",
    attrs: {
      "href": "mailto:jay@kiesys.co.kr"
    }
  }, [_vm._v("jay@kiesys.co.kr")])])]), _c('tr', [_c('td', [_vm._v("Partnership & PQ")]), _c('td', [_vm._v("Jae-ho Roh")]), _c('td', [_c('a', {
    staticClass: "primary--text text-decoration-underline ",
    attrs: {
      "href": "mailto:jhroh@kiesys.co.kr"
    }
  }, [_vm._v("jhroh@kiesys.co.kr")])])])])])], 1)], 1), _c('section', {
    staticClass: "section section--last pt-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit top-line-tit"
  }, [_vm._v("Contact KIE SYSTEMS")])]), _c('form-input', {
    attrs: {
      "skin": "contactus"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }